import axios from 'axios';

const SPA_SERVER_URL = process.env.REACT_APP_SPA_SERVER_URL;
export default axios.create({
  baseURL: SPA_SERVER_URL,
});
